class RodFlow extends React.Component {
  constructor(props) {
    super(props);
    var newState = {
      currentStep: 1,
      stepValues: {
        1: null,
        2: null,
        3: null
      }
    };
    if (typeof props.init != 'undefined') {
      newState = props.init(this, newState);
    }
    this.state = newState;
  }
  goToStep(i) {
    const stepValues = this.state.stepValues;
    if (i > 1 && stepValues[i - 1] == null) {
      return;
    }
    this.setState({
      currentStep: parseInt(i),
      stepValues: stepValues
    });
  }
  handleClickChoice(value) {
    var stepValues = this.state.stepValues;
    var nextStep = this.state.currentStep;

    stepValues[this.state.currentStep] = value;

    if (typeof this.props.content[this.state.currentStep + 1] != 'undefined') {
      nextStep++;
    } else {
      console.log(this.props.content, this.state.currentStep);
      this.props.complete(this.state.stepValues);
    }

    this.setState({
      currentStep: nextStep,
      stepValues: stepValues
    });
  }
  renderHistory() {
    const steps = this.props.content;

    var lis = Object.keys(steps).map(function (key, index) {
      let li = null;
      if (key < this.state.currentStep) {
        li = React.createElement(
          'li',
          { key: key, className: 'past' },
          React.createElement(
            'a',
            { onClick: () => this.goToStep(key), title: steps[key].stepLink },
            key
          )
        );
      } else if (key == this.state.currentStep) {
        li = React.createElement(
          'li',
          { key: key, className: 'current' },
          React.createElement(
            'span',
            { title: steps[key].stepLink },
            key
          )
        );
      } else {
        li = React.createElement(
          'li',
          { key: key, className: 'future' },
          React.createElement(
            'span',
            { title: steps[key].stepLink },
            key
          )
        );
      }
      return li;
    }, this);

    let back = null;
    if (this.state.currentStep > 1) {
      back = React.createElement(
        'ul',
        { className: 'back' },
        React.createElement(
          'li',
          null,
          React.createElement(
            'a',
            { onClick: () => this.goToStep(this.state.currentStep - 1), title: 'Back' },
            '\u2190 Back'
          )
        )
      );
    } else {
      back = React.createElement(
        'ul',
        { className: 'back disabled' },
        React.createElement(
          'li',
          null,
          React.createElement(
            'span',
            null,
            '\u2190 Back'
          )
        )
      );
    }

    let fwd = null;

    return React.createElement(
      'div',
      { className: 'history-nav' },
      back,
      React.createElement(
        'ul',
        null,
        lis
      ),
      fwd
    );
  }
  render() {
    const currentStep = this.state.currentStep;
    const stepValues = this.state.stepValues;
    const totalSteps = Object.keys(this.props.content).length;

    let stepContent = null;

    switch (currentStep) {
      default:
        stepContent = React.createElement(GenericStep, { stepNumber: currentStep, totalSteps: totalSteps, content: this.props.content[currentStep], value: stepValues[currentStep],
          formValues: stepValues, clickChoiceHandler: value => this.handleClickChoice(value) });
        break;
    }

    return React.createElement(
      'div',
      null,
      this.renderHistory(),
      stepContent
    );
  }
}

class GenericStep extends React.Component {
  renderOptions() {
    const options = this.props.content.options;

    var lis = options.map(function (option) {
      if (typeof option.constraints != 'undefined') {
        for (var c in option.constraints) {
          var cstring = '##' + option.constraints[c].join('##') + '##';
          if (!cstring.match('##' + this.props.formValues[c] + '##')) {
            return false;
          }
        }
      }
      return React.createElement(StepOption, { option: option, key: option.index + option.value, stepValue: this.props.formValues[this.props.stepNumber], onClick: () => this.props.clickChoiceHandler(option.value) });
    }, this);

    return React.createElement(
      'ul',
      { className: 'row' },
      lis
    );
  }
  render() {
    return React.createElement(
      'div',
      { className: 'step step-{this.props.stepNumber}' },
      React.createElement(
        'h2',
        { title: 'Step {this.props.stepNumber} of {this.props.totalSteps}: {this.props.content.stepText}' },
        this.props.content.stepText
      ),
      this.renderOptions()
    );
  }
}

class StepN extends GenericStep {}

class StepOption extends React.Component {
  render() {
    let image = null;
    if (this.props.option.image) {
      image = React.createElement('img', { src: this.props.option.image });
    } else {
      image = React.createElement('span', { className: 'no-image' });
    }

    let lightbulb = null;
    if (this.props.option.lightbulb) {
      lightbulb = React.createElement(LightBulb, { content: this.props.option.lightbulb });
    }

    let subtext = null;
    if (this.props.option.subtext) {
      subtext = React.createElement(
        'span',
        { className: 'option-subtext', onClick: () => this.props.onClick() },
        this.props.option.subtext
      );
    }

    let liclass = "col-sm-3";
    if (this.props.option.value == this.props.stepValue) {
      liclass = "col-sm-3 active";
    }

    return React.createElement(
      'li',
      { className: liclass },
      React.createElement(
        'div',
        { className: 'image', onClick: () => this.props.onClick() },
        image
      ),
      React.createElement(
        'span',
        { className: 'option-text', onClick: () => this.props.onClick() },
        this.props.option.text
      ),
      subtext,
      lightbulb
    );
  }
}

class LightBulb extends React.Component {
  render() {
    return React.createElement(
      'div',
      { className: 'lightbulb-wrapper' },
      React.createElement(
        'span',
        { className: 'fa-stack lightbulb-handle' },
        React.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
        React.createElement('i', { className: 'fa fa-lightbulb-o fa-stack-1x fa-inverse' })
      ),
      React.createElement(
        'div',
        { className: 'lightbulb-content' },
        this.props.content
      )
    );
  }
}

// window.RodFlow = React.render(
//   <RodFlow content={FlowContent} />,
//   document.getElementById('rodflow-root')
// );
